export default defineNuxtRouteMiddleware(async to => {
	const appConfig = useAppConfig();
	let url = '/artikl-ne-postoji/';
	if(appConfig?.lang == 'si') {
		url = '/izdelek-ne-obstaja/';
	}

	// Set 404 status for product not found page
	if (to.path === url) {
		setResponseStatus(useRequestEvent(), 404);
	}

	// match url that starts with /p/ and has a number after it
	const regex = to.path.match(/^\/p\/(\d+)(\/|$)/);

	if (regex) {
		const catalog = useCatalog({route: to});
		const {getUrlSegments} = useUrl();
		const code = getUrlSegments(to.path)[1];
		if (!code) return;

		try {
			const res = await catalog.fetchProducts({
				code: code,
				mode: 'url',
				limit: 1,
			});

			if (!res.data?.items?.length) return navigateTo(url, {redirectCode: 301});
			return navigateTo(
				{path: res.data.items[0].url_without_domain, query: {...to.query}},
				{redirectCode: 301}
			);
		} catch (e) {
			console.log(e);
		}
	}
});
